<template>
  <AppLayout>
    <VContainer
      fluid
      fill-height
    >
      <VLayout
        align-center
        justify-center
      >
        <VFlex
          xs12
          md8
        >
          <VCard class="elevation-12">
            <VToolbar
              dark
              color="primary"
            >
              <VToolbarTitle>{{ $t('heading') }}</VToolbarTitle>
              <VSpacer/>
              <VTooltip bottom>
                <VBtn
                  slot="activator"
                  icon
                  large
                  :to="{name: 'home'}"
                >
                  <VIcon large>
                    home
                  </VIcon>
                </VBtn>
                <span>{{ $t('home') }}</span>
              </VTooltip>
            </VToolbar>
            <VCardText>
              <VAlert
                v-if="registrationError"
                :value="true"
                type="error"
              >
                {{ $t('registrationError') }}
              </VAlert>
              <VProgressLinear
                v-else
                :indeterminate="true"
              />
            </VCardText>
            <VCardActions>
              <VSpacer/>
              <VBtn
                v-if="registrationError"
                flat
                :to="{name: 'home'}"
              >
                {{ $t('home') }}
              </VBtn>
            </VCardActions>
          </VCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </AppLayout>
</template>

<script>
import UserApi from '@/api/UserApi'
import { mapActions } from 'vuex'

export default {
  name: 'RegistrationConfirm',
  data () {
    return {
      registrationError: false
    }
  },
  methods: {
    ...mapActions('user', ['setUser'])
  },
  async created () {
    try {
      const authObj = await UserApi.registrationConfirmation(this.$route.query.hash)
      UserApi.makeAuth(authObj)
      this.setUser(authObj.user)
      this.$router.push({ name: 'login' })
    } catch (e) {
      this.registrationError = true
      this.$notification(e)
    }
  },
  i18n: {
    messages: {
      de: {
        heading: 'Registrierung',
        home: 'Zurück',
        registrationError: 'Registrierung konnte nicht abgeschlossen werden'
      },
      en: {

        heading: 'Registration',
        home: 'Back',
        registrationError: 'Could not complete registration'
      }
    }
  }
}
</script>
